import { UserApi } from "../../../api/user";
import { LocalStorageKey, LocalStorageService } from "../../../services/localStorageService";
import { getFirebaseToken } from "../../../services/pushnotification";
import { throwErrorToastAsync } from "../../../services/throwErrorToast";
import { setGlobalLoading, setIsRegisteredToken } from "../../reducers/globalLoading/globalLoading";
import { setUserClaims } from "../../reducers/signup/claims";
import { AppThunk, store } from "../../store";
export interface ILocalStorageUserData {
    token: string;
    organizationId: string;
    phoneNumber: string;
}

const api = new UserApi();

export const getUserClaimsAction = (): any => {
    return async (dispatch: any) => {
        try {
            dispatch(setGlobalLoading(true));
            const { form } = store.getState().userSignupForm;
            const localStorage = new LocalStorageService();

            const response = await api.getUserClaims(form);
            dispatch(setUserClaims(response.token));

            const dateStorage: ILocalStorageUserData = {
                token: response.token,
                organizationId: form.organizationId,
                phoneNumber: form.phoneNumber,
            };
            localStorage.setItem(LocalStorageKey.USER_SIGNUP, JSON.stringify(dateStorage));
            localStorage.setItem(LocalStorageKey.TOKEN, response.token);
            return true;
        } catch (error) {
            throwErrorToastAsync(error);
            return false;
        } finally {
            dispatch(setGlobalLoading(false));
        }
    };
};

export const registerUserNotificationAction = (): AppThunk => async (dispatch) => {
    const localStorage = new LocalStorageService();
    let token = localStorage.getItem(LocalStorageKey.NOTIFICATION);
    try {
        getFirebaseToken()
            .then(async (res: any) => {
                if (token && token !== res) {
                    await api.unregisterUserNotification(token);
                }
                localStorage.setItem(LocalStorageKey.NOTIFICATION, res);
                await api.registerUserNotification(res);
                dispatch(setIsRegisteredToken(true));
            })
            .catch((error) => {
                dispatch(setIsRegisteredToken(false));
                throwErrorToastAsync(error);
            });
    } catch (error) {
        dispatch(setIsRegisteredToken(false));
        throwErrorToastAsync(error);
    }
};

export const unregisterUserNotificationAction = (): AppThunk => async (dispatch) => {
    try {
        const localStorage = new LocalStorageService();
        let token = localStorage.getItem(LocalStorageKey.NOTIFICATION);
        await api.unregisterUserNotification(token);
    } catch (error) {
        throwErrorToastAsync(error);
    }
};
